import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={17.276}
    height={26.596}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 7893 12151"
    {...props}
  >
    <defs>
      <style>
        {
          // ".str0,.str1{stroke:#000;stroke-width:345.364}.str0{stroke-linejoin:round}.fil0{fill:none}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528511695280">
        <path
          d="M173 11670V502c0-182 147-329 329-329h6889c182 0 329 147 329 329v11168c0 170-138 309-308 309H481c-170 0-308-139-308-309z"
          className="fill-none stroke1"
          style={{
            strokeWidth: 345.364,
          }}
        />
        <path
          d="M7720 4025v6182c0 408-331 739-739 739H4646c20-177 47-354 83-529l3-15c114-550 312-1104 228-1658-2-13-13-22-26-22H2959c-13 0-24 9-26 22-49 325-1 650 69 974 50 229 112 457 159 684l3 15c35 175 63 352 83 529H912c-408 0-739-331-739-739V4025c0-408 331-739 739-739h6069c408 0 739 331 739 739zM1317 3286 1046 173h5800l-270 3113z"
          className="fill-none stroke1"
          style={{
            strokeWidth: 345.364,
          }}
        />
        <path
          d="m1711 4112-393-826h5257l-393 815c-71 148-221 242-386 243l-3696 13c-166 0-318-95-389-245zM3421 5313v-955h1051v955c0 59-47 106-106 106h-839c-59 0-106-47-106-106zM1130 1663c674-288 1427-390 2153-292 596 82 1169 294 1764 383s1254 35 1715-352"
          className="fill-none stroke1"
          style={{
            strokeWidth: 345.364,
          }}
        />
        <path
          d="M2975 9746c136-147 344-247 566-270 253-26 505 43 759 60 255 16 552-44 660-236"
          className="fill-none stroke1"
          style={{
            strokeWidth: 345.364,
          }}
        />
        <path
          d="m4732 10402-3 15c-36 175-63 352-83 529-16 147-28 294-36 441-7 147-11 295-11 442 0 83-66 150-149 150H3443c-83 0-149-67-149-150 0-147-4-295-11-442-8-147-20-294-36-441-20-177-48-354-83-529l-3-15c-47-227-109-455-159-684-70-324-118-649-69-974 2-13 13-22 26-22h1975c13 0 24 9 26 22 84 554-114 1107-228 1658zM3301 7409c0-333 405-690 645-1152 239 488 646 819 646 1152s-289 602-646 602c-356 0-645-269-645-602z"
          className="fill-none stroke1"
          style={{
            strokeWidth: 345.364,
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
